import localStorageInstance from "utils/LocalStorage";

export const getVideoPlayerVolume = (playerType, volume = 0) => {
  const savedVolume = localStorageInstance.getItem(`${playerType}PlayerVolume`);
  return savedVolume !== null ? parseFloat(savedVolume) : volume;
};

export const setVideoPlayerVolume = (playerType, volume = 0) => {
  if (volume !== undefined) {
    localStorageInstance.setItem(`${playerType}PlayerVolume`, volume);
  }
};

export const getVideoPlayerMuted = (playerType, muted = false) => {
  const savedMuted = localStorageInstance.getItem(`${playerType}PlayerMuted`);
  const returnValue = savedMuted !== null ? savedMuted === "true" : muted;
  return returnValue;
};

export const setVideoPlayerMuted = (playerType, muted = false) => {
  if (muted !== undefined) {
    localStorageInstance.setItem(`${playerType}PlayerMuted`, String(muted));
  }
};
